module.exports = __webpack_public_path__ + "img/it.1d72a5de.svg";